import { last } from 'lodash'
import { useMatches } from 'react-router-dom'

/**
 * A hook that returns current active page object.
 * If a list of routes is provided, it will return the active route from the list.
 */
export const useActivePage = (routes) => {
  const matches = useMatches()
  let activeRoute
  if (!!routes?.length) {
    activeRoute = routes?.find((route) =>
      matches.find((match) => match.handle?.path === route.path)
    )
    /**
     * use activeRoute.path to get the current active path string
     */
  } else {
    activeRoute = last(matches)
    /**
     * use activeRoute.handle.path to get the current active path string
     */
  }

  return activeRoute
}
